exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabs_box_20EMylib {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 1.2rem;\n  background: #ffffff;\n  overflow: hidden;\n  z-index: 9999999999999999;\n}\n\n.br_JZCXSRxl {\n  border-bottom: 0.026667rem solid #f8f8f8;\n}\n\n.shadow_2IVOWTjK {\n  -webkit-box-shadow: 0 0.106667rem 0.213333rem 0 rgba(0, 0, 0, .04);\n  box-shadow: 0 0.106667rem 0.213333rem 0 rgba(0, 0, 0, .04);\n}\n\n.tabs_2PBdqoKU {\n  width: 100%;\n  height: 1.2rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  -webkit-overflow-scrolling: touch;\n  z-index: 9999999999999;\n}", ""]);

// exports
exports.locals = {
	"tabs_box": "tabs_box_20EMylib",
	"br": "br_JZCXSRxl",
	"shadow": "shadow_2IVOWTjK",
	"tabs": "tabs_2PBdqoKU"
};